import { enableProdMode } from "@angular/core";
import { environment } from "./environments/environment";
import "./extensions";
import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "app.config";
import { ModuleRegistry, ValidationModule } from "ag-grid-community";

if (environment.production) {
  enableProdMode();
} else {
  ModuleRegistry.registerModules([ValidationModule]);
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
